import { reactive } from "vue";

export default class GlobalServices {
	static state = reactive({
		overlayShowLoading: false,
		baseUrl: "",
		httpDomain: "https://web.meari.com.cn/",
		userToken: "",
		userId: "",
		showLogin: false,
		clientType: ""
	});
	/**
	 * @description: loading弹层控制
	 * @param {boolean} show
	 * @return {void}
	 */
	static overlayLoadingShowHandle = (show: boolean): void => {
		this.state.overlayShowLoading = show;
	};
}
